<template>
    <div>
        <div class="with-absolute-button">
            <multi-select class="light-bg" v-model="selectedDmsCabinet" label="name" track-by="id" open-direction="bottom"
                :options="DmsCabinetList" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" 
                :close-on-select="true" :allow-empty="true" :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false" 
                :multiple="false" :placeholder="$t('res_Label_SelectOption')" @search-change="getAllDmsCabinets"
                @input="handleDmsCabinetSelectChanged">
                <template slot="noOptions" slot-scope="props">
                    <div style="text-align:start">
                        {{ $t("res_Msgs_EmptySearch") }}
                    </div>
                </template>
            </multi-select>
            <button @click="openDMSCabinetDialog()">
                <v-icon class="float-right">mdi-format-list-group-plus</v-icon>
            </button>
        </div>

        <v-dialog v-model="showDmsCabinetTreeDialog" content-class="dialog2 address-book-dialog with-fixed-actions">
            <div class="dialog-header" style="z-index: 3000 !important;">
                <h1>{{ $t("res_ButtonText_SelectCabinet") }}</h1>
            </div>
            <div class="dialog-body white-container">
                <DmsCabinetTree 
                    @close-dialog="closeDmsCabinetTreeDialog"
                    @handleSelectedChanged="handleDmsCabinetSelectChanged"
                >
                </DmsCabinetTree>
            </div>
        </v-dialog>

    </div>
</template>


<script>
    import MultiSelect from 'vue-multiselect';
    import constants from '@/assets/js/constants';
    import axios from 'axios';
    import DmsCabinetTree from '../components/DmsCabinetTree.vue';


export default{
    name: 'DmsCabinetSelector',
    components: { 
        MultiSelect,
        DmsCabinetTree
    },
    data(){
        return{
            selectedDmsCabinet: null,
            DmsCabinetList: [ ],
            loading: false,
            showDmsCabinetTreeDialog: false
        }
    },
    methods: {
        getAllDmsCabinets(searchText = ""){
            this.DmsCabinetList = [];
            this.loading = true;
            let url = `${constants.baseApiUrl}DMS/GetAllDmsCabinets?SearchText=${searchText}&CalledFrom=search`;

            axios.get(url, { headers: constants.headers })
            .then(res => {
                if (res != null && res.data != null) {
                    this.DmsCabinetList = res.data;
                }
            })
            .catch(
                error => console.log(error)
            )
            .finally(
                () => { this.loading = false; }
            )
        },
        handleDmsCabinetSelectChanged(selectedCabinet){
            this.selectedDmsCabinet = selectedCabinet
            this.$emit('DmsCabinetSelectChanged', selectedCabinet);
        },
        openDMSCabinetDialog(){
            this.showDmsCabinetTreeDialog = true;
        },
        closeDmsCabinetTreeDialog(){
            this.showDmsCabinetTreeDialog = false
        }
    }
}
</script>